import React, { useEffect, useRef } from 'react'

type Props = {
  src: string
  poster?: string
  className?: string
  style?: React.CSSProperties
}

/**
 * A silent looping video used as moving photography.
 * It only plays while on screen, and not at all for people who ask for reduced motion.
 */
export const LoopVideo = ({ src, poster, className, style }: Props) => {
  const video = useRef<HTMLVideoElement>(null)

  useEffect(() => {
    const element = video.current
    if (!element) return
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) element.play().catch(() => {})
      else element.pause()
    })
    observer.observe(element)
    return () => observer.disconnect()
  }, [])

  return (
    <video
      ref={video}
      src={src}
      poster={poster}
      loop
      muted
      playsInline
      preload='metadata'
      className={className}
      style={style}
    />
  )
}
